<template>
  <v-icon :size="size" :color="color" :disabled="disabled" @click="$emit('click')">
    <slot></slot>
  </v-icon>
</template>

<script>
export default {
  name: 'IconButton',
  props: {
    color: { type: String, required: false, default: '#605D54' },
    size: { type: Number, required: false, default: 25 },
    disabled: { type: Boolean, required: false, default: false }
  }
};
</script>

<style scoped></style>
